export default function getMuxPreview(playbackId: string, time = 0) {
  return `https://image.mux.com/${playbackId}/thumbnail.png?time=${time}`;
}
